import React, {Component} from 'react';
import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import {SERVER_URL}  from '../Constants';




class User extends Component {
    constructor(props) {
      super(props);

        this.state={
            firstName: "",
            lastName:'',
            picUrl:'',
            email:'',
            securityGroup:'',
            phone:'',
            active:true,
            user:null,
            disabled:false,
            employeeId:'',
            resetTickerURL:'',
            etipId:'',
            notAuthorized:false,
            lfReadOnly:false,
            ptReadOnly:false,
            sso:false,
            ssoDomain:'',
        }

    }

    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} timer={5000} lightBackground store={ToastStore}/>
        </div>
    }
    componentDidMount(){

        const { match: { params } } = this.props;

        this.loadUser(params.userId);
        axios.get(`${SERVER_URL}/venue/` + auth0Client.getActiveVenuedId(),{
          headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
        }).then((res)=>{
            const venue = res.data;
            this.setState({
                sso: venue.sso,
                ssoDomain:venue.ssoDomain
            });
           
        });
    }

    loadUser=async(userId)=>{

      try{

     
    const user = (await axios.get(`${SERVER_URL}/Users/${userId}`,
         {headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
         'venueId' : auth0Client.getActiveVenuedId()
        },
           }
      )).data; 
        
        if (!user){
          ToastStore.error("User did not load correctly, please try again");
          return;
        }

        // Loaded the User, set the state fields
        this.setState({
            firstName: user.firstName,
            lastName:user.lastName,
            picUrl:user.picture_url,
            email:user.email,
            securityGroup:user.securityGroup,
            phone:user.phone,
            active:user.active,
            user:user,
            id:user.id,
            userName:user.userName,
            employeeId:user.employeeId,
            etipId:user.etipId,
            lfReadOnly:user.lfReadOnly,
            ptReadOnly:user.ptReadOnly
        })
      }catch(e){
     
        ToastStore.error("Unable to edit user. Non-admin accounts can't view or edit other user accounts. Please contact your administrator or support@bounte.net");
        this.setState({disabled:true})
      }
       

    }

    submit=async()=>{
        // all fields are required
        if (!this.state.firstName) {
            ToastStore.error("First Name is required");
            return false;
        }

        // all fields are required
        if (!this.state.lastName ) {
            ToastStore.error("Last Name is required");
            return false;
        }

        // Store this
        this.setState({
            disabled: true,
          });



          await axios.put(`${SERVER_URL}/Users/`, {
            id:this.state.id,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phone: this.state.phone,
            active: this.state.active,
            securityGroup: this.state.securityGroup,
            employeeId: this.state.employeeId,
            etipId:this.state.etipId,
            lfReadOnly:this.state.lfReadOnly,
            ptReadOnly:this.state.ptReadOnly
    
        }, {
          headers: {    'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                        'venueId' : auth0Client.getActiveVenuedId()
                    }
        })
        .then((res)=>{
            //this.props.history.push('/');
            // Show saved successful
           //alert(res.status);
              this.setState({
                showAlert:false,
                disabled: false,
                showSuccess: true,
      
               });
            ToastStore.success('User Saved Successfully!');
            
    
            
         
        })
        .catch ((e)=>{
            console.log(e);
            this.setState({
                showAlert:true,
                disabled: false,
                error:e,
    
            })
            console.log(e.response.statusText)
            // show error message if available
            ToastStore.error(e.response.statusText);
            
        })





    }

  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  renderGoBack =()=>{
    return (
      <button className="btn btn-secondary" onClick={() => this.props.history.goBack()}><h6> BACK </h6></button>
    )
  }

  // add to LMS
  CreateLMSLogin=async()=>{

      if (!this.state.firstName|| !this.state.lastName){
        alert('The Learning management system requires a first and last name');
        return;
      }

      //console.log(this.state.firstName);
      //return;


      await axios.post(`${SERVER_URL}/LMS/signup`, {
        id:this.state.id,
             

    }, {
      headers: {    'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                    'venueId' : auth0Client.getActiveVenuedId()
                }
    })
    .then((res)=>{
        //this.props.history.push('/');
        // Show saved successful
       //alert(res.status);
          this.setState({
            showAlert:false,
            disabled: false,
            showSuccess: true,
  
           });
        ToastStore.success('User LMS Login Created Successfully. They will now have access to the learning system.');
        

        
     
    })
    .catch ((e)=>{
        console.log(e);
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
        console.log(e.response.statusText)
        // show error message if available
        ToastStore.error(e.response.statusText);
        
    })



    }

    sendInviteEmail=async()=>{
        
      if (this.state.sso){
        alert('This login is managed by your company and not BOUNTE. Please contact your company support staff for password management');
        return;
      }
      await axios.post(`${SERVER_URL}/Users/sendInviteEmail`, {
            id:this.state.id,
                

        }, {
          headers: {    'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                        'venueId' : auth0Client.getActiveVenuedId()
                    }
        })
        .then((res)=>{
             this.setState({
                showAlert:false,
                disabled: false,
                showSuccess: true,
      
              });
            ToastStore.success('User sent invite email, includes password reset option');
            

            
        
        })
        .catch ((e)=>{
            console.log(e);
            this.setState({
                showAlert:true,
                disabled: false,
                error:e,

            })
            console.log(e.response.statusText)
            // show error message if available
            ToastStore.error(e.response.statusText);
            
        })

    }
    renderResetEmail = ()=>{
      if (this.state.sso){
        //alert('This login is managed by your company and not BOUNTE. Please contact your company support staff for password management');
        return;
      }

      return (
        <button
        disabled={this.state.disabled}
        className="btn btn-outline-info btn-sm"
        onClick={() =>this.sendInviteEmail()}>
       Send
      </button>
      )
    }
    renderPasswordResetLink = ()=>{
     
      return (
        <button
        disabled={this.state.disabled}
        className="btn btn-outline-success btn-sm"
        onClick={() =>this.createPasswordLink()}>
      Generate Link
      </button>
      )
    }


    renderLMSLogin = ()=>{
      return (
        <button
        disabled={this.state.disabled}
        className="btn btn-success"
        onClick={() => {this.CreateLMSLogin()}}>
        Enable Access to Learning Module
      </button>
      )
    }

    renderPasswordResetSection=()=>{
      if (this.state.sso){
       
        return null;
      }else{
        return(
          <div>
                    <div className="row">
                    <div className="col-5 text-left">
                        <h6>Send a reset email to the user:</h6>
                  </div>
                    <div className="col-6 text-left">
                        {(this.state.id !==undefined ) && this.renderResetEmail()}
                    
                    </div>
                </div>
                <br/>

                 <br/>
                 <h6>Create a reset link to manually send:</h6><small>(Use this option if email is not accessible)</small>
                 <div classname="input-group mb-3">
   
                  <input type="text" className={(this.state.resetTickerURL) ? "form-control is-valid" : "form-control"} autocomplete="off" data-lpignore="true" value={this.state.resetTickerURL} placeholder="Click generate to create link" aria-label="Recipient's username" aria-describedby="button-addon2"/>
                  {(this.state.id !==undefined ) && this.renderPasswordResetLink()}
                </div>
          </div>
        )
      }
    }

    /************************************************************************************************
    NAME:  createPasswordLink
    *************************************************************************************************/
    createPasswordLink=async()=>{
      await axios.post(`${SERVER_URL}/Users/processPasswordResetTicket`, {
        id:this.state.id,
            
    }, {
      headers: {    'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                    'venueId' : auth0Client.getActiveVenuedId()
                }
    })
    .then((res)=>{
         this.setState({
            showAlert:false,
            disabled: false,
            showSuccess: true,
            resetTickerURL:res.data.ticket,
          });
        ToastStore.success('Password rest URL Created');
        

        
    
    })
    .catch ((e)=>{
        console.log(e);
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
        console.log(e.response.statusText)
        // show error message if available
        ToastStore.error(e.response.statusText);
        
    })
    }
    // Main render function
    render(){


        return(
            <div className='container'>
            
               <div className="row">
                    <div className="col-6 text-left">
                    {this.renderGoBack()}
                      </div>
                      <div className="col-6 text-right">
                      <h2>Edit User</h2>
                    </div>
              </div>

           
       
           
            <br/>
      
        
         
         {this.renderToast()}

        
             <br/>
        <h2 class='text-info'>{this.state.firstName + ' ' + this.state.lastName}</h2>


        <div className="row">
            <div className="col-12">

            <h6 class='text-muted' >{this.state.userName} </h6>
                 
               
                <hr/>
                <h3>Edit User Fields </h3>
                
                 <div className="form-group">
                  <label htmlFor="exampleInputEmail1">First Name:</label>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                     onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="First Name"
                    value = {this.state.firstName}
                    name='firstName'
                    autocomplete="off"
                    data-lpignore="true"
                  />
                   <label htmlFor="exampleInputEmail1">Last Name:</label>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                     onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="Last Name"
                    value = {this.state.lastName}
                    name='lastName'
                    autocomplete="off"
                  />
                   <label htmlFor="employeeId">Employee ID:</label>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                     onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="Employee Id"
                    value = {this.state.employeeId}
                    name='employeeId'
                    autocomplete="off"
                    data-lpignore="true"
                  />

                   <label htmlFor="exampleInputEmail1">Phone:</label>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                     onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="Phone Number"
                    value = {this.state.phone}
                    name='phone'
                    autocomplete="off"
                    data-lpignore="true"
                  />
                      <label htmlFor="employeeId">Tip Setting (optional):</label>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                     onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="Enter eTip ID for staff member"
                    value = {this.state.etipId}
                    name='etipId'
                    autocomplete="off"
                    data-lpignore="true"
                  />

                <label htmlFor="securityGroup"> Group:</label>
                                         
                                         <select className='custom-select'  value={this.state.securityGroup} name='securityGroup' onChange={this.handleInputChange}>
                                          
                                           <option value="admin">Administrator</option>
                                           <option value="">User</option>
                   
                                         </select>
                <div className="form-check">
                      <input
                        disabled={this.state.disabled}
                        type="checkbox"
                        onChange={this.handleInputChange}
                        className="form-check-input"
                        placeholder=""
                        checked = {this.state.active}
                        name='active'
                      />
                    <label htmlFor="exampleInputEmail1"><b>Active : Check to make active.  Uncheck to deactivate User.</b>  </label>
                    </div>
                
                  <div className="form-check">
                      <input
                        disabled={this.state.disabled}
                        type="checkbox"
                        onChange={this.handleInputChange}
                        className="form-check-input"
                        placeholder=""
                        checked = {this.state.lfReadOnly}
                        name='lfReadOnly'
                      />
                    <label htmlFor="exampleInputEmail1" className="text-danger"><b>Lost & Found Read Only : Check to make this user a read-only account for Lost & Found.</b> </label>
                    </div>
                   
                  <div className="form-check">
                      <input
                        disabled={this.state.disabled}
                        type="checkbox"
                        onChange={this.handleInputChange}
                        className="form-check-input"
                        placeholder=""
                        checked = {this.state.ptReadOnly}
                        name='ptReadOnly'
                      />
                    <label htmlFor="exampleInputEmail1" className="text-danger"><b>Parcel Tracking Read Only : Check to make this user a read-only account for Parcel Tracking.</b>  </label>
                    </div>

                    </div>
               
                <div className="row">
                    <div className="col-4">
                      <button
                          disabled={this.state.disabled}
                          className="btn btn-primary text-left"
                          onClick={() => {this.submit()}}>
                          Update
                        </button>
                    </div>
                    
                    
                    
                </div>

                <br/>
                <h3>Password Reset</h3> <p className='text-danger'> {(this.state.sso) ? ': Currently not enabled.  Managed by your company SSO configuration' : ''}</p>
                <hr/>
                {this.renderPasswordResetSection()}

              
               
                </div>
               


        </div>
        <br/><br/><br/><br/>
        </div>


        )
       


    }
}




export default withRouter(User);

